import { EmployeeCostCenter } from '~/data/employee';
import { fetchFromOldApi } from '~/services/Http';

export type EmplHistoryType = {
  fEmpCostCenters?: EmployeeCostCenter[];
  fEmpJobTitle: string;
  fEmpLegalEntity: number;
  fEmpUnitPositions: [];
  fInternalPositionAttachmentId: number;
  fInternalPositionAttachmentName: string;
  fInternalPositionEmpId: number;
  fInternalPositionEndDate: string;
  fInternalPositionEnteredTime: string;
  fInternalPositionEnteredUser: number;
  fInternalPositionId: number;
  fInternalPositionIncludeInOverallExperience: boolean;
  fInternalPositionInfo: string;
  fInternalPositionIsCurrent: boolean;
  fInternalPositionIsPending: boolean;
  fInternalPositionManager: number;
  fInternalPositionPosition: string;
  fInternalPositionStartDate: string;
  fInternalPositionSupersededTime: string;
  fInternalPositionUnit: number;
};

export const getEmplHistory = (
  id: string | number,
): Promise<EmplHistoryType[]> => {
  return fetchFromOldApi(
    '/json/employee/' + id + '/dev/pos/internal?period=historical',
  ).then((r) => r.json());
};
